import type { ReactNode } from 'react';

import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

interface EmptySectionCardProps {
  children: ReactNode;
  disableCard?: boolean;
  variant?: 'default' | 'transparent';
}

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'disableCard' && prop !== 'cardVariant',
})<{
  disableCard?: boolean;
  cardVariant?: 'default' | 'transparent';
}>(({ theme, disableCard, cardVariant }) => {
  const transparent = cardVariant === 'transparent';

  return {
    border: transparent ? 'none' : `1px dashed ${theme.palette.primary.light}`,

    backgroundColor: transparent
      ? 'transparent'
      : disableCard
      ? theme.palette.grey[200]
      : '#f0f6ff',

    textAlign: 'center',
    padding: transparent ? 0 : theme.spacing(6),
    boxShadow: 'none',
  };
});

const EmptySectionCard = ({
  children,
  disableCard = false,
  variant = 'default',
}: EmptySectionCardProps) => (
  <StyledCard
    variant="outlined"
    disableCard={disableCard}
    cardVariant={variant}
  >
    {children}
  </StyledCard>
);

export default EmptySectionCard;
